<template>
  <div class="page">
    <PageHeader />
    <div class="content" id="content">
      <main>
        <div class="prompt-to-play" v-if="competitionEnded() === false">
          Celebrating our collaboration with
          <br />Nokia, Hubraum and T-Mobile PL.
          <a
            href="https://www.youtube.com/watch?v=s_PP1NMoOEk"
            target="_blank"
            @click="handleClickVideo()"
          >Watch now!</a>
          <p class="good-enough">We are launching a 3-week snake contest! Think you’re good enough?</p>
        </div>
        <p class="prompt-to-play" v-else-if="competitionEnded() === true">
          Oh no! We regret to inform you that this
          <br />competition has ended.
        </p>
        <p class="prompt-to-play" v-else>Loading...</p>

        <GameContainer :competitionEnded="competitionEnded()" />
      </main>
      <Prizes :competitionEnded="competitionEnded()" />
      <PageFooter />
      <FooterFloater :expiresOn="expiresOn" />
    </div>
    <ShareModal />
    <EditNameModal />
    <CovveAdModal />
  </div>
</template>


<script>
import PageHeader from "@/components/layout/PageHeader";
import PageFooter from "@/components/layout/PageFooter";
import GameContainer from "@/components/GameContainer";
import Prizes from "@/components/layout/Prizes";
import FooterFloater from "@/components/layout/FooterFloater";

import ShareModal from "@/components/shared/ShareModal";
import EditNameModal from "@/components/shared/EditNameModal";
import CovveAdModal from "@/components/shared/CovveAdModal";

import { trackEvent } from "@/analytics.js";
import { db } from "@/main.js";

export default {
  name: "App",
  components: {
    PageHeader,
    PageFooter,
    GameContainer,
    Prizes,
    ShareModal,
    EditNameModal,
    CovveAdModal,
    FooterFloater
  },
  data() {
    return {
      bokuStatus: "",
      expiresOn: null
    };
  },
  methods: {
    handleClickVideo() {
      trackEvent("sawnokiavid");
    },
    competitionEnded() {
      return this.expiresOn && this.expiresOn - new Date() < 0;
    }
  },
  beforeMount() {
    // if (location.search.includes("boku=success")) this.bokuStatus = "success";
    // else if (location.search.includes("boku=fail")) this.bokuStatus = "fail";
  },
  async mounted() {
    trackEvent("visited snake");
    const data = await db.get().then(r => r.data());
    this.expiresOn = new Date(data.expiresOn);
  }
};
</script>


<style lang="scss">
html {
  font-family: "Press Start 2P";
  font-size: 16px;
  line-height: 28px;
  height: 100%;
  width: 100%;
}

.page .content {
  width: 70%;
  margin: 0 auto;
  position: relative;
}

a {
  display: inline-block;
  color: $accent-color;
  text-decoration: none;
  // padding-bottom: 4px;
  // box-shadow: inset 0 0px 0 white, inset 0 -4px 0 $accent-color;
  &:hover {
    color: $accent-hover-color;
    box-shadow: inset 0 0px 0 white, inset 0 -4px 0 $accent-hover-color;
  }
}

main {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  margin: 80px 0;
  .prompt-to-play {
    margin: 0px auto;
    margin-bottom: 70px;
    text-align: center;
    line-height: 32px;
  }
  .good-enough {
    font-size: 11px;
    text-align: center;
    background: #ec008b;
    border-radius: 9px;
    padding: 3px 30px;
    margin-top: 50px;
  }
}

.page {
  min-height: 100vh;
  min-width: 300px;
  color: white;
  background-color: #19002d;
  background-image: linear-gradient(
      180deg,
      rgba(26, 0, 51, 0) 0%,
      #1a0033 104.93%
    ),
    url("assets/bg-top.png"), url("assets/bg-bottom.png");
  background-attachment: inherit, inherit, fixed;
  background-position: top, top, bottom;
  background-repeat: no-repeat;
  background-size: auto, contain, contain;
  position: relative;
  padding: 40px 0 95px;
}

@media (max-width: 1440px) {
  .page .content {
    width: 90%;
  }
}

@media (max-width: 768px) {
  html {
    font-family: "Press Start 2P";
    font-size: 12px;
    line-height: 18px;
  }

  main {
    margin: 10px 0;
  }

  .page {
    padding: 10px 0;
    background-size: auto, auto, auto;
    background-position: 0px -140px;
  }

  .page .content {
    width: 100%;
    padding: 0 5px;
    margin: 0 auto;
    padding-bottom: 20px;
  }

  .good-enough {
    margin-right: 20px;
    margin-left: 20px;
    font-size: 8px;
    padding: 3px 10px;
    line-height: 25px;
  }
}

.alert {
  margin: 50px 0;
  padding: 10px;
  border: solid 5px;
  &.success {
    border-color: green;
  }

  &.fail {
    border-color: red;
  }
}
</style>
